import { gql } from '@apollo/client'
import { useActionMutation, type UseActionResult, type UseMutationProps } from '@ztechapps/common.hook'
import type { FulfillAdjustmentArgs, WorkOrder } from '@ztechapps/common.contract'
import { adjustmentFragment } from './graphql'

export const fulfillAdjustmentQuery = gql`
  mutation fulfillAdjustment($input: FulfillAdjustmentArgs!) {
    fulfillAdjustment(input: $input) {
      ...adjustmentFragment
    }
  }
  ${adjustmentFragment}
`

export const useFulfillAdjustment = (
  { query, ...props } = {} as UseMutationProps
): UseActionResult<WorkOrder, FulfillAdjustmentArgs> => {
  query = query ?? fulfillAdjustmentQuery

  return useActionMutation({
    query,
    ...props,
  })
}
